import { DatagridContext, DatagridContextValue } from './DatagridContext';
import { PropsWithChildren, ReactElement } from 'react';

type DatagridContextProviderProps = PropsWithChildren<{ value: DatagridContextValue }>;

function DatagridContextProvider({ children, value }: DatagridContextProviderProps): ReactElement {
  return <DatagridContext.Provider value={value}>{children}</DatagridContext.Provider>;
}
export { DatagridContextProvider };
export type { DatagridContextProviderProps };
